module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/sms-d322541addfdea1c59bdbb6b3d99521b.svg";